import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"outlined":"","dense":"","hide-details":"","clearable":"","rules":_vm.requiredRule,"label":"Event type","items":_vm.calendarEvents,"item-value":"node.valName","item-text":"node.valName"},on:{"change":function($event){return _vm.$emit('event-changed', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }